export default __webpack_public_path__ + "static/media/temperature.b0067582.svg";